import React, { useState, useEffect, useRef } from 'react';
import axios from '../../services/MyAxios';
import SpinnerGrowLoading from './SpinnerGrowLoading';

export default function PlainMetric({ url, label }) {
    const [data, setData] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const requestController = useRef(new AbortController());

    useEffect(() => {
        setIsLoading(true);
        axios
            .get(url, {
                signal: requestController.current.signal,
            })
            .then((response) => {
                setIsLoading(false);
                setData(response.data);
            });
        return () => requestController.current.abort();
    }, []);

    return (
        <div className="card">
            <div className="card-body">
                <span className="text-muted">{label}</span>
                <SpinnerGrowLoading isLoading={isLoading}>
                    <h3 className="font-light m-b-5">{data}</h3>
                </SpinnerGrowLoading>
            </div>
        </div>
    );
}
